import styled from 'styled-components';

const StyledButton = styled.button`
{
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  border-radius: 8px;
  border: 2px solid ${({ color }) =>
    color === 'white' ? '#EDEDED' : '#62AA48'};
  background: ${({ color }) => (color === 'white' ? '#EDEDED' : '#62AA48')};
  color: ${({ color }) => (color === 'white' ? '#1B131F' : '#FFFFFF')};
  padding: 19px 36px;
  font-family: Instrument Sans;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 26px;
  
  @media screen and (max-width: 1024px){
    padding: 16px 28px;
  }

  @media screen and (max-width: 425px){
    padding: 14px 16px;
    font-size: 16px;
    line-height: 20px;    
  }

`;

const ActionButton = ({ color = 'white', children, className }) => {
  return (
    <StyledButton color={color} className={className}>
      {children}
    </StyledButton>
  );
};

export default ActionButton;
